module.exports = __webpack_public_path__ + "static/media/google-pay.07b98f97.svg";